import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';

import UserInput from "../UI/ReactUserInput";
import UserInputTextarea from "../UI/ReactUserInputTextarea";
import BootstrapRow from "ui/BootstrapRow";

function computeLostSessionTotal( data )
{
	let t1 = 0 ;
	let t2 = 0 ;

	if ( data.unauthorised_absences != null )
	{
		t1 = data.unauthorised_absences ;
	}

	if ( data.authorised_absences != null )
	{
		t2 = data.authorised_absences ;
	}

	return +t1 + +t2 ;
}

function ChildAttendanceRow( props, ref )
{
	const { attendanceData } = props ;

	const attendanceDaysRef = useRef( null ) ;
	const attendanceTotalRef = useRef( null ) ;
	const attendanceReasonsRef = useRef( null ) ;
	const unauthorisedAbsencesRef = useRef( null ) ;
	const authorisedAbsencesRef = useRef( null ) ;

	const [ lostSessionTotal, setLostSessionTotal ] = useState( () => computeLostSessionTotal( attendanceData )) ;

	useEffect( () => {
		setLostSessionTotal( computeLostSessionTotal( attendanceData )) ;
	}, [ attendanceData.unauthorised_absences, attendanceData.authorised_absences ]) ;

	function calcTotalDaysLost()
	{
		let calc = 0 ;

		if ( unauthorisedAbsencesRef.current != null )
		{
			let unauthorised_absences = unauthorisedAbsencesRef.current.getValue() ;

			if ( unauthorised_absences == null || unauthorised_absences == '' )
			{
				unauthorised_absences = 0 ;
			}

			let authorised_absences = authorisedAbsencesRef.current.getValue() ;

			if ( authorised_absences == null || authorised_absences == '' )
			{
				authorised_absences = 0 ;
			}

			calc = +unauthorised_absences + +authorised_absences ;
		}
		else
		{
			calc = +attendanceData.unauthorised_absences + +attendanceData.authorised_absences ;
		}

		return calc ;
	}

	function recalcPercentages()
	{
		setLostSessionTotal( calcTotalDaysLost()) ;
	}

	useImperativeHandle( ref, () => ({
		getFormData()
		{
			var att = {} ;

			att.attended_days = attendanceDaysRef.current.getValue() ;
			att.out_of_days = attendanceTotalRef.current.getValue() ;
			att.reason = attendanceReasonsRef.current.getValue() ;
			att.unauthorised_absences = unauthorisedAbsencesRef.current.getValue() ;
			att.authorised_absences = authorisedAbsencesRef.current.getValue() ;

			return att ;
		},

		isDirty()
		{
			var result = false ;

			if ( attendanceDaysRef.current.isDirty() )
			{
				result = true ;
			}

			if ( unauthorisedAbsencesRef.current.isDirty() )
			{
				result = true ;
			}

			if ( authorisedAbsencesRef.current.isDirty() )
			{
				result = true ;
			}

			if ( attendanceTotalRef.current.isDirty() )
			{
				result = true ;
			}

			if ( attendanceReasonsRef.current.isDirty() )
			{
				result = true ;
			}

			return result ;
		},

		setDirty( value )
		{
			attendanceDaysRef.current.setDirty( value ) ;
			attendanceTotalRef.current.setDirty( value ) ;
			attendanceReasonsRef.current.setDirty( value ) ;
			unauthorisedAbsencesRef.current.setDirty( value ) ;
			authorisedAbsencesRef.current.setDirty( value ) ;

			if ( value == false )
			{
				if ( props.setDirty != null )
				{
					props.setDirty( value ) ;
				}
			}
		}
	})) ;

	const fieldType = ( props.readonly === true || props.mode === 'view'  ) ? 'readonly' : '' ;

	return (
		<div>
			<div className="row attendance-panel">
				<div className="col-1 col-md-3">
					<UserInput
						validation={{ required: false, maxlen: 3, isInteger: true }}
						name="InputAttendanceDays"
						ref={attendanceDaysRef}
						labelText="Actual Sessions Attended"
						errorText="Valid number required"
						value={attendanceData.attended_days}
						tabIndex={props.tabIndex + 1}
						readOnly={fieldType}
						displayErrors={props.displayErrors}
						autoComplete="off"
						onDirty={props.onDirty}
					/>
				</div>
				<div className="col-1 col-md-3">
					<UserInput
						validation={{ required: false, maxlen: 3, isInteger: true }}
						name="InputAttendanceTotal"
						ref={attendanceTotalRef}
						labelText="Out of possible"
						errorText="Valid number required"
						value={attendanceData.out_of_days}
						tabIndex={props.tabIndex + 2}
						readOnly={fieldType}
						displayErrors={props.displayErrors}
						onDirty={props.onDirty}
						autoComplete="off"
					/>
				</div>
				<div className="col-1 col-md-2">
					<UserInput
						validation={{ required: false, maxlen: 3, isInteger: true }}
						name="InputUnauthorisedAbsences"
						ref={unauthorisedAbsencesRef}
						labelText="Unauthorised absences"
						errorText="Valid number required"
						value={attendanceData.unauthorised_absences}
						autoComplete="off"
						tabIndex={props.tabIndex + 3}
						readOnly={fieldType}
						displayErrors={props.displayErrors}
						onBlur={recalcPercentages}
						onDirty={props.onDirty}
					/>
				</div>
				<div className="col-1 col-md-2">
					<UserInput
						validation={{ required: false, maxlen: 3, isInteger: true }}
						name="InputAuthorisedAbsences"
						ref={authorisedAbsencesRef}
						labelText="Authorised absences"
						errorText="Valid number required"
						value={attendanceData.authorised_absences}
						autoComplete="off"
						tabIndex={props.tabIndex + 4}
						readOnly={fieldType}
						displayErrors={props.displayErrors}
						onBlur={recalcPercentages}
						onDirty={props.onDirty}
					/>
				</div>
				<div className="col-1 col-md-2">
					<UserInput
						validation={{ required: false, maxlen: 3, isInteger: true }}
						name="InputAttendanceTotalSessionsLost"
						labelText="Total sessions lost"
						errorText="Valid number required"
						value={lostSessionTotal}
						autoComplete="off"
						tabIndex={props.tabIndex + 99}
						readOnly="readonly"
						displayErrors={props.displayErrors}
						onDirty={props.onDirty}
					/>
				</div>
			</div>
			<BootstrapRow>
				<div className="col-1 col-md-12">
					<UserInputTextarea
						validation={{ required: false, maxlen: 255 }}
						name="InputAttendanceReasons"
						ref={attendanceReasonsRef}
						label="Comments"
						rows={props.reasonRows}
						errorText="This must be a valid input"
						value={attendanceData.reason}
						tabIndex={props.tabIndex + 5}
						readOnly={fieldType}
						displayErrors={props.displayErrors}
						onDirty={props.onDirty}
					/>
				</div>
			</BootstrapRow>
		</div>
	) ;
}

const ChildAttendanceRowWithRef = forwardRef( ChildAttendanceRow ) ;

ChildAttendanceRowWithRef.defaultProps =
	{
		displayErrors: false,
		reasonRows: 3,
		attendanceData:
			{
				attended_days: 0,
				out_of_days: 0,
				unauthorised_absences: 0,
				authorised_absences: 0,
				reason: ''
			}
	} ;

export default ChildAttendanceRowWithRef ;